import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('GpuExercise', LATEST_SCHEMA_VERSION.GpuExercise);
export default exerciseTypeVersionAdapter;